angular.module('aprima-provider-api').factory('AttachmentApprovalRepository', ['AprimaRestangular',
    function (AprimaRestangular) {
        'use strict';

        var approve = function (messageUid, attachmentUid) {
            var restangular = AprimaRestangular.get();
            return restangular.one('aamessage', messageUid).one('approve', attachmentUid).post();
        };


        return {
            approve: approve
        };

    }]);